import request from "@/utils/request";

// 创建视频目录
export const createVideoCatalog = (data) => {
    return request({
        url: "/businessservice/videoCatalog/create",
        method: "post",
        data: data
    })
}

// 更新视频目录
export const updateVideoCatalog = (data) => {
    return request({
        url: "/businessservice/videoCatalog/update",
        method: "post",
        data: data
    })
}

// 树查询
export const treeVideoCatalog = (data) => {
    return request({
        url: "/businessservice/videoCatalog/tree",
        method: "post",
        data: data
    })
}

// 删除
export const  deleteVideoCatalog =(query) =>{
    return request({
        url: "/businessservice/videoCatalog/delete",
        method:"get",
        params: query
    })
}